module.exports = __webpack_public_path__ + "media/images/emblems/Saint-Gingolph_Wappen-c742392033b1d6e98845cf794e232eec.svg";